import z from 'zod';

export interface UserNeedDto {
  id: number;
  userId: string;
  title: string;
  categoryId: number;
  subcategoryId: number;
  status: string;
  note: string;
  sortOrder: number;
  createdAt: number;
  updatedAt: number;
}

export interface CreateUserNeedRequestDto {
  userId: string;
  title: string;
  categoryId?: number;
  subcategoryId?: number;
  status: string;
  note?: string;
}

export const CreateUserNeedRequestSchema = z.object({
  userId: z.string(),
  title: z.string(),
  categoryId: z.number().optional(),
  subcategoryId: z.number().optional(),
  status: z.string(),
  note: z.string().optional(),
});

export type CreateUserNeedRequest = z.infer<typeof CreateUserNeedRequestSchema>;

export const UpsertUserNeedRequestSchema = CreateUserNeedRequestSchema.extend({
  userNeedId: z.number().optional(),
});

export type UpsertUserNeedRequest = z.infer<typeof UpsertUserNeedRequestSchema>;

export interface UpsertUserNeedRequestDto extends CreateUserNeedRequestDto {
  userNeedId?: number;
}

export interface UpdateUserNeedRequestDto {
  title?: string;
  categoryId?: number;
  subcategoryId?: number;
  status?: string;
  note?: string;
}

export interface UserNeedHistoryDto {
  interactionId: number;
  externalItemId: number;
  externalItemType: string;
  createdAt: number;
  title: string;
}

export interface LegacyNeedCategoryDto {
  id: number;
  key: string;
  name: string;
  subcategories?: NeedSubcategoryDto[];
}

export interface NeedSubcategoryDto {
  id: number;
  key: string;
  name: string;
  needCategoryId: number;
}

export interface UpdateUserNeedSortOrderDto {
  op: 'move';
  id: number;
  after: number;
}

export const fulfillNeedSchema = z
  .object({
    description: z.string().nonempty('Required'),
  })
  .strict();

export type FulfillNeedForm = z.infer<typeof fulfillNeedSchema>;
